import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { LockClock } from '@mui/icons-material';
import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import './YettostartCourseModal.scss';

/**
 * Centered modal shown when a user taps a course whose enrollment has not
 * started yet (course_user.course_status = 'yettostart'). The course start
 * date comes from course_user.starts_on (unix seconds, 12:00 AM IST).
 *
 * Show it by passing the course object (needs course_title, starts_on is
 * optional) and hide it via onHide (set the course state back to null).
 */
export const YettostartCourseModal = ({ course, onHide }) => (
  <Modal show={Boolean(course)} onHide={onHide} centered>
    <Modal.Body>
      <div className='YettostartCourseModal__lockCircle mx-auto'>
        <LockClock />
      </div>
      <p className='YettostartCourseModal__heading text-center mt-3 mb-1'>Course locked</p>
      {course?.starts_on ? (
        <p className='YettostartCourseModal__text text-center mb-0'>
          <span className='font-bold'>{course.course_title}</span> will start on{' '}
          <span className='YettostartCourseModal__date'>
            {format(fromUnixTime(course.starts_on), 'do MMMM yyyy')}
          </span>
          . See you then!
        </p>
      ) : (
        <p className='YettostartCourseModal__text text-center mb-0'>
          <span className='font-bold'>{course?.course_title}</span> has not started yet. You will
          get access once the course begins.
        </p>
      )}
    </Modal.Body>
    <Modal.Footer className='justify-content-center'>
      <Button variant='customPrimary' onClick={onHide}>
        Got it
      </Button>
    </Modal.Footer>
  </Modal>
);

YettostartCourseModal.propTypes = {
  course: PropTypes.instanceOf(Object),
  onHide: PropTypes.func.isRequired,
};

YettostartCourseModal.defaultProps = {
  course: null,
};